import Box from "@mui/material/Box";

import React from "react";

interface SectionWrapperProps {
  children: React.ReactNode;
  id?: string;
}

export default function SectionWrapper({ children, id }: SectionWrapperProps) {
  return (
    <Box
      id={id}
      sx={{
        px: "var(--section-margin-x, 40px)",
        py: "var(--section-margin-y, 40px)",
        my: "var(--section-margin-between, 10px)",
      }}
    >
      {children}
    </Box>
  );
}
